import React from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import CircularLoading from '../loadings/CircularLoading'
import { withStyles } from '@material-ui/core'
import { styles } from '../../styles/js/baseDialog'

/**
 * Material-UI Dialog with repetitive features across all dialogs
 * @param {*} props
 */
const BaseDialog = ({
  classes,
  dialog,
  setDialog,
  onClose,
  title,
  description,
  actionTitle,
  secondaryActionTitle,
  actionStatusRequest,
  handleAction,
  handleSecondaryAction,
  disabledAction,
  slug,
  fullWidth,
  maxWidth,
  statusRequest,
  children,
}) => {
  /**
   * Function that closes dialog by changing its state
   */
  const handleClose = () => {
    setDialog({ isOpen: false, data: null })
    if (onClose) {
      onClose()
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleAction()
    }
  }

  return (
    <Dialog
      open={!!dialog.isOpen}
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-labelledby={`dialog-${slug}`}
      PaperProps={{
        className: classes.root,
        onKeyPress: handleKeyPress,
      }}
      scroll='body'
    >
      <Button
        className={classes.closeButton}
        onClick={handleClose}
        color='secondary'
        variant='contained'
      >
        <CloseIcon style={{ color: '#fff' }} />
      </Button>
      {title && (
        <DialogTitle
          id={`dialog-${slug}`}
          disableTypography
          style={{ paddingBottom: 0 }}
        >
          <Typography variant='h2' className={classes.title}>
            {title}
          </Typography>
          {description && (
            <Typography variant='h5' className={classes.description}>
              {description}
            </Typography>
          )}
        </DialogTitle>
      )}

      <br />
      <br />

      {children && (
        <>
          {!statusRequest || statusRequest.done ? (
            <DialogContent classes={{ root: classes.contentRoot }}>
              {children}
            </DialogContent>
          ) : (
            <CircularLoading size={34} />
          )}
        </>
      )}

      <DialogActions className={classes.dialogActions}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            {secondaryActionTitle && (
              <Button
                size='small'
                onClick={handleSecondaryAction}
                className={classes.secondaryActionButton}
                variant='outlined'
                color='primary'
                disabled={
                  actionStatusRequest || (statusRequest && !statusRequest.done)
                }
              >
                {actionStatusRequest ? (
                  <CircularProgress size={18} />
                ) : (
                  secondaryActionTitle
                )}
              </Button>
            )}
          </Grid>

          <Grid item xs={6}>
            {actionTitle && (
              <Button
                size='small'
                onClick={handleAction}
                className={classes.actionButton}
                variant='contained'
                color='primary'
                disabled={
                  actionStatusRequest ||
                  (statusRequest && !statusRequest.done) ||
                  disabledAction
                }
              >
                {actionStatusRequest ? (
                  <CircularProgress size={18} />
                ) : (
                  actionTitle
                )}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles)(BaseDialog)
